import MainLayout from '../layouts/main';
import ComplaintsRegistration from './complaints-registration';

function ComplaintsRegistrationPage() {
  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      <ComplaintsRegistration/>
    </MainLayout>
  );
}

export default ComplaintsRegistrationPage;
